export default "/_next/static/assets/images/high-five-striped-background.e25df6be84b23b39275d807eaba80fd4.png";